/**
 * Maps error objects to user-friendly error messages
 * @param {Error|Object} error - The error object
 * @returns {string} User-friendly error message
 */
export const getErrorMessage = (error) => {
  if (!error) return 'An unexpected error occurred. Please try again.';

  const errorString = (error.message || error.toString() || '').toLowerCase();

  // Check patterns in order of specificity
  const patterns = [
    [['timeout', 'timed out'], 'Query timed out. Try a smaller search scope or fewer filters.'],
    [['network', 'connection', 'fetch', 'failed to fetch'], 'Connection lost. Please check your internet connection and try again.'],
    [['429', 'rate limit', 'too many requests'], 'Too many requests. Please wait a moment and try again.'],
    [['signalr', 'websocket', 'connection closed'], 'Connection to server lost. Please refresh the page and try again.'],
    [['500', '502', '503', '504', 'internal server error'], 'Server error. Please try again in a few moments.'],
    [['404', 'not found'], 'Resource not found. Please check your search and try again.'],
    [['401', 'unauthorized', 'authentication'], 'Authentication required. Please log in again.'],
  ];

  for (const [keywords, message] of patterns) {
    if (keywords.some(keyword => errorString.includes(keyword))) {
      return message;
    }
  }

  return 'Unable to load graph. Please try again or contact support if the problem persists.';
};
